import { type Trigger, TriggerType } from '@keyvue/one-api-client';

// eslint-disable-next-line import/prefer-default-export
export function getMergeContentForTrigger(trigger: Trigger) {
    switch (trigger.type.value) {
        case TriggerType.REALWORKS_AGENDA.value: return getMergeContentForAgendaTrigger();
        case TriggerType.REALWORKS_TAAK.value: return getMergeContentForTaakTrigger();
        case TriggerType.REALWORKS_RELATIE.value: return getMergeContentForRelatieTrigger();
        case TriggerType.REALWORKS_KENMERK.value: return getMergeContentForKenmerkTrigger();
        case TriggerType.REALWORKS_BIRTHDAY.value: return getMergeContentForBirthdayTrigger();
        default: return [];
    }
}

function getMergeContentForAgendaTrigger() {
    return [];
}

function getMergeContentForTaakTrigger() {
    return [];
}

function getMergeContentForRelatieTrigger() {
    return [];
}

function getMergeContentForKenmerkTrigger() {
    return [];
}

function getMergeContentForBirthdayTrigger() {
    return [];
}
